"use strict";

exports.__esModule = true;
exports.TextPresetNames = void 0;
let TextPresetNames;
exports.TextPresetNames = TextPresetNames;
(function (TextPresetNames) {
  TextPresetNames["BodyL"] = "Body-L";
  TextPresetNames["BodyM"] = "Body-M";
  TextPresetNames["BodyS"] = "Body-S";
  TextPresetNames["BodyXS"] = "Body-XS";
  TextPresetNames["HeadingL"] = "Heading-L";
  TextPresetNames["HeadingM"] = "Heading-M";
  TextPresetNames["HeadingS"] = "Heading-S";
  TextPresetNames["HeadingXL"] = "Heading-XL";
  TextPresetNames["Menu"] = "Menu";
  TextPresetNames["PageTitle"] = "Page-title";
  TextPresetNames["Title"] = "Title";
})(TextPresetNames || (exports.TextPresetNames = TextPresetNames = {}));
//# sourceMappingURL=types.js.map